
import { PriceListProduct } from '@/model/PriceListProduct';
import { cloneDeep, isEqual, uniqueId } from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Product from "./Product.vue";

@Component({
    components: {
        Product,
    }
})
export default class ProductsDialog extends Vue {
    preventDialogClose = false;
    selectedTab: number = 0;
    currentTab: number = 0;
    @Prop({
        required: true,
        type: Array,
        default: [],
    })
    value!: Array<{ _id: any, model: PriceListProduct }>;
    dialogOpen = false;
    public exitRunBlink = false;
    private exitRunBlinkTimeout: number | null = null;

    photoProducts: Array<{ _id: string; model: (PriceListProduct | null) }> = [];
    globalProducts: Array<{ _id: string; model: (PriceListProduct | null) }> = [];

    get allProducts() {
        return [ ...this.photoProducts, ...this.globalProducts ];
    }

    get additionalServiceCount() {
        return this.allProducts.filter(({ model }) => model && !!model.name).length;
    }

    closeDialog() {
        if (this.preventDialogClose) {
            (this.$refs.dialog as any).animateClick();
        } else {
            this.dialogOpen = false;
        }
    }

    @Watch('allProducts', {
        deep: true
    })
    allProductsChanged() {
        Vue.nextTick(() => {
            this.revalidate();
            if (
                this.isValid() &&
                !isEqual(this.allProducts.filter(({ model }) => !!model), this.value)
            ) {
                console.log('emit input');
                this.$emit('input', cloneDeep(this.allProducts).filter(({ model }) => !!model));
            }
        });
    }

    @Watch('value', { immediate: true })
    productsChanged() {
        this.photoProducts = cloneDeep(this.value
            .filter(({ model }) => !model?.global));
        this.globalProducts = cloneDeep(this.value
            .filter(({ model }) => !!model?.global));

        if (this.photoProducts.length === 0) {
            this.photoProducts = [ { _id: uniqueId(), model: null } ];
        }

        if (this.globalProducts.length === 0) {
            this.globalProducts = [ { _id: uniqueId(), model: null } ];
        }
    }

    addPhotoProduct() {
        this.photoProducts.push({
            _id: uniqueId(),
            model: null
        });
    }

    addGlobalProduct() {
        this.globalProducts.push({
            _id: uniqueId(),
            model: null
        });
    }

    revalidate() {
        Vue.nextTick(() => {
            this.preventDialogClose = !this.isValid();
        });
    }

    isValid() {
        const productComponents = [ ...(this.$refs.photoProducts || []) as any[], ...(this.$refs.globalProducts || []) as any[]];

        return productComponents.reduce((prev, curr) => prev && (curr.isEmpty || curr.validate()), true);
    }

    onDialogClose(e?: KeyboardEvent) {
        if (e instanceof KeyboardEvent && e.key !== 'Escape') {
            return;
        }

        if (this.preventDialogClose) {
            this.flashExitRun();
            const dialog = this.$refs.dialog as any;
            if (dialog && typeof dialog.animateClick === 'function') {
                dialog.animateClick();
            }
        }
    }

    private flashExitRun() {
        this.exitRunBlink = false;
        if (this.exitRunBlinkTimeout) {
            window.clearTimeout(this.exitRunBlinkTimeout);
            this.exitRunBlinkTimeout = null;
        }

        this.$nextTick(() => {
            this.exitRunBlink = true;
            this.exitRunBlinkTimeout = window.setTimeout(() => {
                this.exitRunBlink = false;
                this.exitRunBlinkTimeout = null;
            }, 900);
        });
    }

    beforeDestroy() {
        if (this.exitRunBlinkTimeout) {
            window.clearTimeout(this.exitRunBlinkTimeout);
            this.exitRunBlinkTimeout = null;
        }
    }

    onTabChange() {
        let productComponents: any[];
        if (this.currentTab === 0) {
            productComponents = (this.$refs.photoProducts || []) as any[];
        } else {
            productComponents = (this.$refs.globalProducts || []) as any[];
        }

        if (!this.isValid()) {
            this.$nextTick(() => this.selectedTab = this.currentTab);
        } else {
            this.currentTab = this.selectedTab;
        }
    }

    deleteProduct(id: string) {
        this.photoProducts = this.photoProducts.filter(({ _id }) => _id !== id);
    }

    deleteGlobalProduct(id: string) {
        this.globalProducts = this.globalProducts.filter(({ _id }) => _id !== id);
    }
}
